import React from "react";

/**
 * Panel: border instead of a shadow, small radius, dense spacing.
 * title/icon: header (heading + quiet icon), action: element on the right of the header (e.g. "Detalji").
 * onClick is only a mouse convenience; keyboard users need an explicit `action` button.
 */
export default function Card({ children, className = "", padded = true, title, icon: Icon, action, onClick }) {
  return (
    <section
      onClick={onClick}
      className={`rounded-xl border border-slate-200 bg-surface shadow-card dark:border-slate-800 dark:bg-slate-900 dark:shadow-card-dark
        ${padded ? "p-4" : ""}
        ${onClick ? "cursor-pointer transition-colors hover:border-slate-300 dark:hover:border-slate-700" : ""}
        ${className}`}
    >
      {(title || action) && (
        <div className={`flex items-center justify-between gap-3 ${padded ? "mb-3" : "px-4 pt-4 pb-3"}`}>
          <div className="flex min-w-0 items-center gap-2">
            {Icon && <Icon aria-hidden="true" className="shrink-0 text-base text-slate-500 dark:text-slate-400" />}
            {title && <h3 className="truncate text-sm font-semibold text-slate-900 dark:text-slate-100">{title}</h3>}
          </div>
          {action}
        </div>
      )}
      {children}
    </section>
  );
}
